export const IconTwitter = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="white"/>
<path d="M15.6623 7H17.3498L13.6641 11.2116L18 16.9435H14.6058L11.9455 13.4681L8.90504 16.9435H7.21512L11.1567 12.4379L7 7H10.4802L12.8824 10.1767L15.6623 7ZM15.0695 15.9348H16.0041L9.9711 7.95611H8.96719L15.0695 15.9348Z" fill="#404040"/>
</svg>
`